module.exports = __webpack_public_path__ + "img/phone.45607f5f.webp";